import { render, staticRenderFns } from "./Rotation.vue?vue&type=template&id=0d990ee2&scoped=true&"
import script from "./Rotation.vue?vue&type=script&lang=js&"
export * from "./Rotation.vue?vue&type=script&lang=js&"
import style0 from "./Rotation.vue?vue&type=style&index=0&id=0d990ee2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d990ee2",
  null
  
)

export default component.exports